import { Menu as MuiMenu, MenuProps as MuiMenuProps, styled } from "@mui/material";

const StyledMenu = styled(MuiMenu)(() => {
  return {
    marginTop: "1rem",
    padding: "1rem 0.5rem",
    borderRadius: "2rem",
  };
});

interface MenuProps extends MuiMenuProps {
  children?: React.ReactNode;
}

export const Menu: React.FC<MenuProps> = ({ children, ...props }) => {
  return <StyledMenu {...props}> {children}</StyledMenu>;
};

export default Menu;
